import { useNavigate } from 'react-router-dom';
import { Button } from "@mui/material"
import {
  useGetSessionQuery,
  useGetUserInfoQuery,
  useSendSurveyMutation
} from '../services/api';
import { isSessionEnded } from '../isInSession';
import { useDispatch } from 'react-redux';
import { toast } from '../features/snackbar/snackbarSlice';

export function PractitionerActions({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean;
}) {
  const { data: user } = useGetUserInfoQuery();

  if (user?.role === 'member')
    return null;

  return (
    <PractitionerActionsInternal
      guid={guid}
      inSession={inSession}
    />
  );
}

function PractitionerActionsInternal({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean;
}) {
  const { data: session } = useGetSessionQuery(guid);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendSurvey] = useSendSurveyMutation();
  const ended = isSessionEnded(session)

  const handleSendSurvey = async () => {
    await sendSurvey(guid)
      .unwrap()
      .then(() => {
        dispatch(
          toast({
            message: 'Survey successfully sent.',
            severity: 'success'
          })
        )
      })
      .catch((err: any) => {
        dispatch(
          toast({
            message: String(err),
            severity: 'error'
          })
        )
      })
  }

  return (
    <>
      {ended
        ? (
          <Button
            fullWidth
            onClick={handleSendSurvey}
            style={{
              marginRight: 8,
            }}
            variant="contained"
          >
            Send Survey
          </Button>
        )
        : (
          <Button
            disabled={!inSession}
            fullWidth
            onClick={() => navigate(`/room/${guid}`)}
            variant='contained'
          >
            Start Session
          </Button>
        )
      }
    </>
  );
}